<template>
  <div>
    <h6 v-if="profileId == 0" class="heading-small text-muted mb-4">
      Add New Brand {{ inputName ? " - " + this.inputName : "" }}
    </h6>
    <h6
      v-else-if="profileId != 0 && this.$attrs.viewMode == true"
      class="heading-small text-muted mb-4"
    >
      View Brand - {{ this.inputName }}
    </h6>
    <h6 v-else class="heading-small text-muted mb-4">
      Edit Brand - {{ this.inputName }}
    </h6>

    <base-alert v-if="errors.length" type="danger">
      <b>You have the following error(s):</b>
      <li v-for="error in errors" :key="error">{{ error }}</li>
    </base-alert>

    <b-tabs
      v-show="profileId != 0 && this.$attrs.viewMode == true"
      content-class="mt-3"
    >
      <b-tab title="Details" active v-on:click="openDetails"></b-tab>
      <b-tab title="History" v-on:click="openHistory">
        <b><label>Created By: </label></b>
        {{ brand.created_by || "System"  }} | {{ brand.created_at | dateFilter }}
        <br />
        <b><label>Updated By:</label></b>
        {{ brand.updated_by || "System"  }} | {{ brand.updated_at | dateFilter }}
      </b-tab>
    </b-tabs>

    <form id="form-proper">
      <!-- {{brand}} -->
      <div v-if="customFormMode == 1" v-show="showDetails">
        <!-- Normal -->
        <base-input
          alternative=""
          label="Code"
          placeholder=""
          v-model="brand.code"
          input-classes="form-control"
        />
        <base-input
          alternative=""
          label="Name"
          placeholder=""
          v-model="brand.name"
          input-classes="form-control"
          required
        />
        <base-input
          alternative=""
          label="Refcode"
          placeholder=""
          v-model="brand.refcode"
          input-classes="form-control"
        />

        <base-input label="Brand Category">
          <div class="form-group row">
              <div class="col-sm-6">
                  <input type="text" class="form-control" v-model="brandCategory" disabled>
              </div>
              <div class="col-sm-6">
                  <autocomplete
                      ref="autocomplete"
                      placeholder="Search Brand Category"
                      :source="brandCategoriesEndpoint"
                      input-class="form-control"
                      results-property="data"
                      :results-display="formattedDisplay"
                      :request-headers="authHeaders"
                      @selected="getBrandCategory">
                  </autocomplete>
              </div>
          </div>
        </base-input>

        <base-input label="Record Owner">
        <div class="form-group row">
            <div class="col-sm-6">
                <input type="text" class="form-control" v-model="recordOwner" disabled>
            </div>
            <div class="col-sm-6">
                <autocomplete
                    ref="autocomplete"
                    placeholder="Search Record Owner"
                    :source="companiesEndpoint"
                    input-class="form-control"
                    results-property="data"
                    :results-display="formattedDisplay"
                    :request-headers="authHeaders"
                    @selected="getRecordOwner">
                </autocomplete>
            </div>
        </div>
      </base-input>

      <base-input label="Brand Owner">
        <div class="form-group row">
            <div class="col-sm-6">
                <input type="text" class="form-control" v-model="brandOwner" disabled>
            </div>
            <div class="col-sm-6">
                <autocomplete
                    ref="autocomplete"
                    placeholder="Search Brand Owner"
                    :source="companiesEndpoint"
                    input-class="form-control"
                    results-property="data"
                    :results-display="formattedDisplay"
                    :request-headers="authHeaders"
                    @selected="getBrandOwner">
                </autocomplete>
            </div>
        </div>
      </base-input>

        <base-input alternative="" label="Remark">
          <textarea rows="4" class="form-control" v-model="brand.remark" />
        </base-input>

      </div>
      <div v-if="customFormMode == 2" v-show="showDetails">
        <!-- Override -->
        <dynamic-form
          :convertedJson="{ mode: customForm.mode, groups: customForm.groups }"
          :formSettings="brand.extras"
          @valueUpdated="updateSettings"
          :key="dynamicFormKey"
        />
      </div>
      <div v-if="customFormMode == 3" v-show="showDetails">
        <!-- Append -->
        <a-tabs defaultActiveKey="1">
          <a-tab-pane tab="Basic" key="1">
            <base-input
              alternative=""
              label="Code"
              placeholder=""
              v-model="brand.code"
              input-classes="form-control"
            />
            <base-input
              alternative=""
              label="Name"
              placeholder=""
              v-model="brand.name"
              input-classes="form-control"
              required
            />
            <base-input
              alternative=""
              label="Refcode"
              placeholder=""
              v-model="brand.refcode"
              input-classes="form-control"
            />

            <base-input label="Brand Category">
              <div class="form-group row">
                  <div class="col-sm-6">
                      <input type="text" class="form-control" v-model="brandCategory" disabled>
                  </div>
                  <div class="col-sm-6">
                      <autocomplete
                          ref="autocomplete"
                          placeholder="Search Brand Category"
                          :source="brandCategoriesEndpoint"
                          input-class="form-control"
                          results-property="data"
                          :results-display="formattedDisplay"
                          :request-headers="authHeaders"
                          @selected="getBrandCategory">
                      </autocomplete>
                  </div>
              </div>
            </base-input>

            <base-input label="Record Owner">
              <div class="form-group row">
                  <div class="col-sm-6">
                      <input type="text" class="form-control" v-model="recordOwner" disabled>
                  </div>
                  <div class="col-sm-6">
                      <autocomplete
                          ref="autocomplete"
                          placeholder="Search Record Owner"
                          :source="companiesEndpoint"
                          input-class="form-control"
                          results-property="data"
                          :results-display="formattedDisplay"
                          :request-headers="authHeaders"
                          @selected="getRecordOwner">
                      </autocomplete>
                  </div>
              </div>
            </base-input>

            <base-input label="Brand Owner">
              <div class="form-group row">
                  <div class="col-sm-6">
                      <input type="text" class="form-control" v-model="brandOwner" disabled>
                  </div>
                  <div class="col-sm-6">
                      <autocomplete
                          ref="autocomplete"
                          placeholder="Search Brand Owner"
                          :source="companiesEndpoint"
                          input-class="form-control"
                          results-property="data"
                          :results-display="formattedDisplay"
                          :request-headers="authHeaders"
                          @selected="getBrandOwner">
                      </autocomplete>
                  </div>
              </div>
            </base-input>

            <base-input alternative="" label="Remark">
              <textarea rows="4" class="form-control" v-model="brand.remark" />
            </base-input>

          </a-tab-pane>
          <a-tab-pane tab="Custom Fields" key="2">
            <dynamic-form
              :convertedJson="{
                mode: customForm.mode,
                groups: customForm.groups_append,
              }"
              :formSettings="brand.extras"
              @valueUpdated="updateSettings"
              :key="dynamicFormKey"
              :showErrors="false"
            />
          </a-tab-pane>
        </a-tabs>
      </div>

      <div v-if="this.$attrs.viewMode != true">
        <div
          v-if="serverType == 'ho'"
          style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;"
        >
          <button
            v-if="profileId == 0"
            type="button"
            class="btn btn-primary float-right"
            @click.prevent="create"
          >
            Create
          </button>
          <button
            v-else
            type="button"
            class="btn btn-primary float-right"
            @click.prevent="update"
          >
            Update
          </button>
        </div>
        <div
          v-else
          style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;"
        >
          <button
            type="button"
            class="btn btn-primary float-right"
            @click.prevent="$emit('closeDrawer', null)"
          >
            Close
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import HTTPRequest from "../../controllers/httpRequest.js";
import ValidateField from "../../components/validateFormUtils.js";
import secureStorage from '../../controllers/secureStorage.js'
import DynamicForm from "../DynamicForm.vue";
import { mapState } from "vuex";
import Autocomplete from 'vuejs-auto-complete'

import moment from "moment";
var component_x;
export default {
  components: {
    DynamicForm,Autocomplete
  },
  computed: {
    ...mapState(["endPoint", "profileId", "serverType"]),
  },
  mounted: async function() {
    const sytemModule = await HTTPRequest.getRequest(
      this.endPoint + "system_modules/Brand?field_name=name",
      null
    );
    const sytemModuleId = sytemModule.id;
    const accSystemModuleRequest = await HTTPRequest.getRequest(
      this.endPoint +
        "account_system_modules/" +
        sytemModuleId +
        "?field_name=system_module_id",
      null
    );
    if (this.isJsonString(accSystemModuleRequest.meta) == true) {
      const accSystemModule = JSON.parse(accSystemModuleRequest.meta);
      if (accSystemModule != null) {
        if (accSystemModule.form_mode != undefined) {
          this.customFormMode = accSystemModule.form_mode;
        }
        if (accSystemModule.customized_forms != undefined) {
          this.customForm = accSystemModule.customized_forms;
        }
      }
    }

    if (this.serverType == "branch" || this.$attrs.viewMode == true) {
      var form = document.getElementById("form-proper");
      var elements = form.elements;
      for (var i = 0, len = elements.length; i < len; ++i) {
        elements[i].readOnly = true;
      }
    }
    component_x = this;
    if (component_x.profileId > 0) {
      var brand_data = await HTTPRequest.getRequest(
        component_x.endPoint + "brands/" + component_x.profileId,
        null
      );
      
      if (brand_data == undefined) {
        component_x.$router.go();
      } else {
        if (brand_data["error"] == undefined) {
          component_x.brand = brand_data;
          component_x.inputName = brand_data["name"];
          component_x.inputCode = brand_data["code"];
          component_x.inputRefcode = brand_data["refcode"];
          component_x.inputRemark = brand_data["remark"];
          component_x.brandCategory = brand_data["brand_category_name"];
          component_x.brandOwner = brand_data["brand_owner_name"];
          component_x.recordOwner = brand_data["record_owner_name"]
        } else {
          this.errors = brand_data["error"].split(",");
        }
      }
    }
    

    this.dynamicFormKey++;
  },
  data: function() {
    return {
      authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
      inputName: "",
      inputCode: "",
      inputRemark: "",
      errors: [],
      showDetails: true,

      customFormMode: 1,
      customForm: {},
      profileData: {},
      dynamicFormKey: 0,
      brand: {},
      formErrors: [],
      brandCategory: null,
      brandOwner: null,
      recordOwner: null
    };

  },
  filters: {
    dateFilter: function(timestamp) {
      return moment(timestamp).format("L LTS");
    },
  },
  methods: {
    formattedDisplay(result) {
      return result.name
    },
    brandCategoriesEndpoint(input) {
      return this.endPoint + '/brand_categories?code=' + input
    },
    companiesEndpoint(input){
      return this.endPoint + '/companies?code=' + input
    },
    getBrandCategory(group) {
        this.brandCategory = group.display
        this.brand.brand_category_id = group.value
    },
    getBrandOwner(group) {
        this.brandOwner = group.display
        this.brand.brand_owner_id = group.value
    },
    getRecordOwner(group) {
        this.recordOwner = group.display
        this.brand.record_owner_id = group.value
    },
    updateSettings(newFormSettings, settingsGrouping, errors) {
      var formSettingsCopy = this.brand;
      var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
      this.formErrors = errors;
      if (this.customFormMode == 3) {
        this.errors = errors;
      }
      this.brand = mergedHash;
      this.brand.extras = newFormSettings
    },
    isJsonString(str) {
      try {
        var json = JSON.parse(str);
        return typeof json === "object";
      } catch (e) {
        return false;
      }
    },
    openDetails() {
      this.showDetails = true;
    },
    openHistory() {
      this.showDetails = false;
    },
    validateForm() {
      this.errors = [];
      // this.errors.push(ValidateField.required('Code', this.inputCode));
      // this.errors.push(ValidateField.alphanumericWithSpecialChars('Code', this.brand.code));
      this.errors.push(
        ValidateField.required("Brand Category", this.brandCategory)
      )
      this.errors.push(
        ValidateField.required("Record Owner", this.recordOwner)
      )
      this.errors.push(
        ValidateField.required("Brand Owner", this.brandOwner)
      )
      this.errors.push(
        ValidateField.charMinAndMax("Code", this.brand.code, 0, 30)
      );
      this.errors.push(
        ValidateField.charMinAndMax("Refcode", this.brand.refcode, 0, 30)
      );
      this.errors.push(ValidateField.required("Name", this.brand.name));
      // this.errors.push(ValidateField.alphanumericWithSpecialChars('Name', this.brand.name));
      this.errors.push(
        ValidateField.charMinAndMax("Name", this.brand.name, 0, 50)
      );
      this.errors = this._.compact(this.errors);
      document.getElementsByClassName(
        "ant-drawer-wrapper-body"
      )[0].scrollTop = 0;
      return this.errors.length;
    },
    create: async function() {
      if (!this.validateForm()) {
        // var brandPayload = {
        //     brand: {
        //         name: this.inputName.trim(),
        //         code: this.inputCode.trim(),
        //         remark: this.inputRemark,
        //         status: 'A'
        //     }
        // }

        this.brand.name = this.brand.name.trim();
        if (this.brand.code != undefined)
          this.brand.code = this.brand.code.trim();
        if (this.brand.refcode != undefined)
          this.brand.refcode = this.brand.refcode.trim();
        this.brand.status = "A";

        var brandPayload = { brand: this.brand };

        var post_request = await HTTPRequest.postRequest(
          this.endPoint + "brands",
          null,
          brandPayload
        );
        if (post_request == undefined) {
          this.$emit("refreshPage", event);
        } else {
          if (post_request["error"] == undefined) {
            this.$emit("refreshPage", event);
          } else {
            this.errors = post_request["error"].split(",");
          }
        }
      }
    },
    update: async function() {
      if (!this.validateForm()) {
        // var brandPayload = {
        //     brand: {
        //         name: this.inputName.trim(),
        //         code: this.inputCode.trim(),
        //         remark: this.inputRemark,
        //         status: 'A'
        //     }
        // }

        this.brand.name = this.brand.name.trim();
        if (this.brand.code != undefined)
          this.brand.code = this.brand.code.trim();
        if (this.brand.refcode != undefined)
          this.brand.refcode = this.brand.refcode.trim();
        // this.brand.status = 'A'
        let status = this.brand.status == null ? "A" : this.brand.status;
        this.brand.status = status;
        var brandPayload = { brand: this.brand };

        var put_request = await HTTPRequest.putRequest(
          this.endPoint + "brands/" + this.profileId,
          null,
          brandPayload
        );
        if (put_request == undefined) {
          this.$emit("refreshPage", event);
        } else {
          if (put_request["error"] == undefined) {
            this.$emit("refreshPage", event);
          } else {
            this.errors = put_request["error"].split(",");
          }
        }
      }
    },
  },
};
</script>

<style></style>
